module.exports = __webpack_public_path__ + "static/media/person-2.f810d7c7.jpg";